import baseService from '../shared/baseService';

const clientCutoutService = (clientId: number) => baseService(`clients/${clientId}/cutouts`);

export default { 
    clientCutoutService
};

